<template>
  <v-app>
    <v-main  :style="$vuetify.breakpoint.xs ? 'padding:0px!important;margin-top: 10px;' : 'padding:0px!important;margin-top: 10px;'">
      <!-- Animated Background -->
      <div class="animated-bg">
        <div class="gradient-overlay"></div>
        <div class="floating-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
        </div>
      </div>

      <v-container class="content-container">
        <v-row justify="center" align="center" style="min-height: 100vh;">
          <v-col cols="12" md="10" lg="8" xl="7">

            <!-- Main Card -->
            <v-card class="main-card" elevation="24">

              <!-- Header Section -->
              <div class="header-section">
                <div class="logo-container">
                  <div class="logo-wrapper elevation-8">
                    <img
                      src="@/assets/img/logo.png"
                      alt="AutoSyncX"
                      class="autosync-logo"
                    />
                  </div>
                </div>
                <h1 class="main-title white--text mb-3">Welcome to AutoSyncX™</h1>
                <p class="main-subtitle white--text">Connect with us and discover your perfect vehicle</p>

                <!-- Referrer Badge -->
                <v-chip
                  v-if="referrerName"
                  color="white"
                  class="referrer-chip elevation-4 mt-4"
                  large
                >
      
                  <span >Referred by <span class="font-weight-bold"></span>{{ referrerName }}</span> </span>
                  <v-icon right color="green" class="material-icons-round">check_circle</v-icon>
                </v-chip>
              </div>

              <!-- Content Section -->
              <v-card-text class="content-section pa-8">
                <h2 class="section-title text-center mb-8">Choose Your Connection Method</h2>

                <v-row>
                  <!-- Voice Agent Card -->
                  <v-col cols="12" md="6" class="mb-4">
                    <v-card
                      class="connection-card voice-card"
                      elevation="8"
                      @click="callVoiceAgent"
                    >
                      <div class="card-glow voice-glow"></div>
                      <v-card-text class="pa-6">
                        <div class="text-center mb-4">
                          <v-avatar size="80" color="blue" class="elevation-6 pulse-animation">
                            <span class="material-icons-round white--text" style="font-size: 48px;">phone_in_talk</span>
                          </v-avatar>
                        </div>

                        <h3 class="text-h4 font-weight-bold text-center mb-3 blue--text">Voice Agent</h3>
                        <p class="text-center text-subtitle-1 grey--text text--darken-2 mb-4">
                          Talk to our AI-powered voice assistant
                        </p>

                        <div class="phone-display mb-4">
                          <v-chip color="blue" dark large block class="justify-center">
                            <span class="material-icons-round mr-2">phone</span>
                            <span class="text-h6 font-weight-bold">{{ formattedPhone }}</span>
                          </v-chip>
                        </div>

                        <v-list dense class="transparent">
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">Instant Connection</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">24/7 Availability</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">Natural Conversation</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-btn
                          color="blue"
                          x-large
                          block
                          class="mt-4 white--text font-weight-bold"
                          elevation="4"
                          @click.stop="callVoiceAgent"
                        >
                          <span class="material-icons-round mr-2">call</span>
                          Call Now
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Chat Agent Card -->
                  <v-col cols="12" md="6" class="mb-4">
                    <v-card
                      class="connection-card chat-card"
                      elevation="8"
                      @click="chatWithAgent"
                    >
                      <div class="card-glow chat-glow"></div>
                      <v-card-text class="pa-6">
                        <div class="text-center mb-4">
                          <v-avatar size="80" color="orange" class="elevation-6 pulse-animation">
                            <span class="material-icons-round white--text" style="font-size: 48px;">chat_bubble</span>
                          </v-avatar>
                        </div>

                        <h3 class="text-h4 font-weight-bold text-center mb-3 orange--text">Chat Agent</h3>
                        <p class="text-center text-subtitle-1 grey--text text--darken-2 mb-4">
                          Message our intelligent chat assistant
                        </p>

                        <div class="chat-preview mb-4">
                          <div class="chat-bubble">
                            <span class="material-icons-round mr-2">smart_toy</span>
                            <span>Hi! How can I help you today?</span>
                          </div>
                        </div>

                        <v-list dense class="transparent">
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">Instant Responses</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">Rich Media Support</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <span class="material-icons-round green--text">check_circle</span>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">Conversation History</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-btn
                          color="orange"
                          x-large
                          block
                          class="mt-4 white--text font-weight-bold"
                          elevation="4"
                          @click.stop="chatWithAgent"
                        >
                          <span class="material-icons-round mr-2">chat</span>
                          Start Chat
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Info Banner -->
                <v-alert
                  color="green"
                  colored-border
                  border="left"
                  elevation="2"
                  class="mt-6 info-banner"
                >
                  <div class="d-flex align-center">
                    <v-avatar size="48" color="green" class="mr-4">
                      <span class="material-icons-round white--text">verified</span>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold text-h6 green--text">Your Referral is Secured</div>
                      <div class="text-subtitle-2 grey--text text--darken-2">
                        Your referral tag is automatically saved before you connect
                      </div>
                    </div>
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Loading Dialog -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="blue" dark>
        <v-card-text class="pt-4">
          <div class="text-center">
            <v-progress-circular indeterminate color="white" class="mb-3"></v-progress-circular>
            <div>{{ loadingText }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

export default {
  name: 'BeamerClubReferral',
  data() {
    return {
      trackingId: '',
      referrerName: '',
      voiceAgentPhone: null,
      parentAgentName: '',
      loading: false,
      loadingText: 'Processing...'
    };
  },
  computed: {
    formattedPhone() {
      if (!this.voiceAgentPhone) {
        return '+1 (217) 598-3215';
      }

      // Format phone number as +1 (XXX) XXX-XXXX
      const cleaned = this.voiceAgentPhone.replace(/\D/g, '');

      if (cleaned.length === 11 && cleaned.startsWith('1')) {
        // US number with country code
        return `+1 (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7)}`;
      } else if (cleaned.length === 10) {
        // US number without country code
        return `+1 (${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
      }

      // Return as-is if format is unexpected
      return this.voiceAgentPhone;
    }
  },
  mounted() {
    this.trackingId = this.$route.params.trackingId;
    if (this.trackingId) {
      this.trackReferral();
    }
  },
  methods: {
    async trackReferral() {
      try {
        const response = await axios.get(`/api/lead-referral/track/${this.trackingId}`);

        if (response.data.flag === 1) {
          this.referrerName = response.data.data.referrer_name;
          this.voiceAgentPhone = response.data.data.voice_agent_phone;
          this.parentAgentName = response.data.data.parent_agent_name;
          // Store tracking ID in localStorage for later use
          localStorage.setItem('referral_tracking_id', this.trackingId);
        }
      } catch (error) {
        console.error('Error tracking referral:', error);
      }
    },
    async callVoiceAgent() {
      try {
        // Call API to create call session
        if (this.trackingId) {
          const response = await axios.post('/api/lead-referral/create-call-session', {
            tracking_id: this.trackingId
          });

          if (response.data.flag === 1) {
            console.log('Call session created:', response.data.data);

            // Store tracking ID in localStorage as backup
            localStorage.setItem('referral_tracking_id', this.trackingId);
          }
        }
      } catch (error) {
        console.error('Error creating call session:', error);
      }

      // Open phone dialer with voice agent phone or fallback
      const phoneNumber = this.voiceAgentPhone || '+12175983215';
      // Remove any formatting characters for tel: link
      const cleanPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');
      window.location.href = `tel:${cleanPhone}`;
    },
    chatWithAgent() {
      // Store tracking ID before opening chat
      if (this.trackingId) {
        localStorage.setItem('referral_tracking_id', this.trackingId);
      }
      
      // Redirect to chat agent page (you can customize this URL)
      this.$router.push('/beamer-club-assistant');
    }
  }
};
</script>

<style scoped>
/* Main Container */
.main-container {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Animated Background */
.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.4) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(118, 75, 162, 0.4) 0%, transparent 50%);
  animation: gradientShift 15s ease infinite;
}

@keyframes gradientShift {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

/* Floating Shapes */
.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 20s infinite ease-in-out;
}

.shape-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  right: 10%;
  animation-delay: 5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 20%;
  animation-delay: 10s;
}

.shape-4 {
  width: 250px;
  height: 250px;
  top: 40%;
  right: 30%;
  animation-delay: 15s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

/* Content Container */
.content-container {
  position: relative;
  z-index: 1;
}

/* Main Card */
.main-card {
  border-radius: 32px !important;
  overflow: hidden;
  background: white;
  backdrop-filter: blur(10px);
}

/* Header Section */
.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 60px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.header-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: rotate 30s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.logo-container {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
}

.logo-wrapper {
  display: inline-block;
  background: white;
  padding: 20px;
  border-radius: 24px;
  animation: logoFloat 3s ease-in-out infinite;
}

.autosync-logo {
  height: 80px;
  width: auto;
  display: block;
}

@keyframes logoFloat {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.main-title {
  font-size: 48px !important;
  font-weight: 800 !important;
  position: relative;
  z-index: 1;
  text-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.main-subtitle {
  font-size: 20px !important;
  position: relative;
  z-index: 1;
  opacity: 0.95;
}

.referrer-chip {
  position: relative;
  z-index: 1;
  font-size: 16px !important;
  padding: 8px 16px !important;
  height: auto !important;
}

/* Content Section */
.content-section {
  background: white;
}

.section-title {
  font-size: 32px !important;
  font-weight: 700 !important;
  color: #2c3e50;
  position: relative;
  display: inline-block;
  width: 100%;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 2px;
}

/* Connection Cards */
.connection-card {
  border-radius: 24px !important;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  background: white;
  height: 100%;
}

.connection-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, transparent 0%, rgba(102, 126, 234, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.connection-card:hover::before {
  opacity: 1;
}

.connection-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
}

.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.voice-glow {
  background: radial-gradient(circle, rgba(102, 126, 234, 0.3) 0%, transparent 70%);
}

.chat-glow {
  background: radial-gradient(circle, rgba(118, 75, 162, 0.3) 0%, transparent 70%);
}

.connection-card:hover .card-glow {
  opacity: 1;
  animation: glowPulse 2s ease-in-out infinite;
}

@keyframes glowPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Pulse Animation */
.pulse-animation {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(102, 126, 234, 0);
  }
}

/* Phone Display */
.phone-display {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 12px;
}

/* Chat Preview */
.chat-preview {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 16px;
}

.chat-bubble {
  background: white;
  padding: 12px 16px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  animation: chatBounce 2s ease-in-out infinite;
}

@keyframes chatBounce {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

/* Info Banner */
.info-banner {
  border-radius: 16px !important;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .main-title {
    font-size: 36px !important;
  }

  .main-subtitle {
    font-size: 18px !important;
  }

  .section-title {
    font-size: 24px !important;
  }

  .header-section {
    padding: 40px 20px;
  }

  .connection-card {
    margin-bottom: 20px;
  }

  .autosync-logo {
    height: 60px;
  }

  .logo-wrapper {
    padding: 15px;
  }
}

@media (max-width: 600px) {
  .main-title {
    font-size: 28px !important;
  }

  .main-subtitle {
    font-size: 16px !important;
  }

  .section-title {
    font-size: 20px !important;
  }

  .autosync-logo {
    height: 50px;
  }

  .logo-wrapper {
    padding: 12px;
  }
}
</style>

